var _rect, _rect2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.349088,
    y: 0.349088,
    width: 59.3018,
    height: 59.3018,
    rx: 29.6509,
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 0.698176
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.23 25.4157V22.1361C37.23 18.2011 33.9868 15 30 15C26.0132 15 22.77 18.2011 22.77 22.1361V25.4157C21.211 25.6053 20 26.9175 20 28.5065V37.3377C20 39.0566 21.4163 40.4545 23.1579 40.4545H36.8421C38.5837 40.4545 40 39.0566 40 37.3377V28.5065C40 26.9174 38.7884 25.6052 37.23 25.4157ZM31.0136 32.9571C31.0362 33.0423 31.0525 33.1301 31.0525 33.2221V36.2988C31.0525 36.8722 30.5809 37.3377 29.9999 37.3377C29.4189 37.3377 28.9473 36.8722 28.9473 36.2988V33.2221C28.9473 33.1301 28.9631 33.0423 28.9862 32.9571C28.3268 32.6007 27.8746 31.9182 27.8746 31.1239C27.8746 29.9655 28.8261 29.0263 29.9998 29.0263C31.1735 29.0263 32.125 29.9654 32.125 31.1239C32.125 31.9182 31.6724 32.6007 31.0134 32.9571H31.0136ZM34.0721 25.3899H25.9279V22.1364C25.9279 19.9203 27.7547 18.1172 30 18.1172C32.2453 18.1172 34.0721 19.9203 34.0721 22.1364V25.3899Z",
    fill: "#CCCCCC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocked);
export default __webpack_public_path__ + "static/media/locked.3c3c39577df197f2faf037c6c6838ba2.svg";
export { ForwardRef as ReactComponent };